import { render, staticRenderFns } from "./PositionSelect.vue?vue&type=template&id=b8780f7c&"
import script from "./PositionSelect.vue?vue&type=script&lang=js&"
export * from "./PositionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports